import { getUserToken, setUserToken } from "./userToken";




export default {



    set (key,val) {
        if (key === "user_token") {
            setUserToken(val)
            return
        }
        try {
            localStorage.setItem(key, JSON.stringify(val))
        }catch(e){
            return ''
        }
    },




    get (key) {
        if (key === "user_token") {
            return getUserToken()
        }
        try {
            return JSON.parse(localStorage.getItem(key))
        }catch(e){
            return ''
        }
        
    },




    remove (key) {
        if (key === "user_token") {
            setUserToken("")
            return
        }
        try{
            localStorage.removeItem(key)
        }catch(e){
            return ''
        }
        
    }
}
